/* tslint:disable */
/* eslint-disable */
/**
 * Project Client API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { WorkedUnit } from './';
import {
    WorkedUnitFromJSON,
    WorkedUnitFromJSONTyped,
    WorkedUnitToJSON,
} from './';

/**
 * 
 * @export
 * @interface ActivityReportResource
 */
export interface ActivityReportResource {
    /**
     * Number of work for the current lot
     * @type {number}
     * @memberof ActivityReportResource
     */
    workedAmount?: number;
    /**
     * 
     * @type {WorkedUnit}
     * @memberof ActivityReportResource
     */
    workedUnit?: WorkedUnit;
}

/**
 * Check if a given object implements the ActivityReportResource interface.
 */
export function instanceOfActivityReportResource(value: object): value is ActivityReportResource {
    return true;
}

export function ActivityReportResourceFromJSON(json: any): ActivityReportResource {
    return ActivityReportResourceFromJSONTyped(json, false);
}

export function ActivityReportResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ActivityReportResource {
    if (json == null) {
        return json;
    }
    return {
        
        'workedAmount': json['workedAmount'] == null ? undefined : json['workedAmount'],
        'workedUnit': json['workedUnit'] == null ? undefined : WorkedUnitFromJSON(json['workedUnit']),
    };
}

export function ActivityReportResourceToJSON(value?: ActivityReportResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'workedAmount': value['workedAmount'],
        'workedUnit': WorkedUnitToJSON(value['workedUnit']),
    };
}

